import { I18n } from '@calendly/i18n';
import { Link } from '@calendly/ui/components/link';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerCss = "ctphrwv";
export const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const previewLinkContainerCss = "p1uyp55l";
const PreviewLinkContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(previewLinkContainerCss, props.className)} />;
});
const PreviewLink = props => <PreviewLinkContainer>
    <Link {...props} />
  </PreviewLinkContainer>;
const controlLinkContainerCss = "cv6p9kn";
const ControlLinkContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(controlLinkContainerCss, props.className)} />;
});
const ControlLink = props => <ControlLinkContainer>
    <MinimalButton {...props} fontSize="medium" />
  </ControlLinkContainer>;
const labelCss = "l14v3fyi";
const Label = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(labelCss, props.className)} />;
});
export const LinkPreview = ({
  url,
  children
}) => <>
    <Label>{I18n.t('publisher.components.editor.visit_url')}</Label>
    <PreviewLink href={url} target="_blank" rel="noopener noreferrer">
      {children ?? url}
    </PreviewLink>
  </>;
export const ControlButtons = ({
  onEdit,
  onRemove
}) => <>
    {onEdit && <ControlLink onClick={onEdit}>
      {I18n.t('publisher.components.editor.edit')}
    </ControlLink>}
    <ControlLink onClick={onRemove}>
      {I18n.t('publisher.components.editor.remove')}
    </ControlLink>
  </>;
const tooltipBodyUseNarrowTooltipCss = "t536cdc";
const tooltipBodyCss = "t5iv37o";
export const TooltipBody = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    top,
    left,
    useNarrowTooltip = false,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const style = {
    top,
    left
  };
  return <Component ref={ref} {...restProps} style={style} className={classNames(tooltipBodyCss, {
    [tooltipBodyUseNarrowTooltipCss]: useNarrowTooltip
  }, props.className)} />;
});

require("./parts.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./parts.js");